import { combineReducers } from "redux";

import { i18n } from "../../shared/reducers/i18n";
import { locale } from "../../shared/reducers/locale";
import { account } from "../../shared/reducers/account";
import { message } from "../../shared/reducers/message";
import { isLoading } from "../../shared/reducers/isLoading";
import { logoPath } from "../../shared/reducers/logoPath";
import { pageContent } from "../../shared/reducers/pageContent";
import { filter } from "../../shared/reducers/filter";
import { dialog } from "../../shared/reducers/dialog";
import { branding } from "./branding";
import configuratorPreviewSelection from "../../buyer_portal/reducers/configuratorPreviewSelection";
import cloudinaryEnv from "../../shared/reducers/cloudinaryEnv";

export const combinedReducers = combineReducers({
  branding,
  i18n,
  locale,
  account,
  message,
  isLoading,
  logoPath,
  pageContent,
  filter,
  dialog,
  configuratorPreviewSelection,
  cloudinaryEnv
});
